<template>
  <q-toggle
    v-if="!isEditingTranslationModel || !hideWhenTranslating"
    v-bind="$attrs"
    ref="inputComponent"
    :model-value="fieldValue"
    :disable="computedDisable"
    data-test-id="model-form-toggle"
    @update:model-value="handleInput"
  >
    <untranslatable-field-tooltip v-if="isEditingTranslationAndFieldNotTranslatable" />

    <template
      v-for="slotName in computedSlots"
      #[slotName]="slotProps"
    >
      <slot
        v-bind="slotProps ?? {}"
        :name="slotName"
      />
    </template>
  </q-toggle>
</template>

<script>
import UntranslatableFieldTooltip from 'src/modules/admin/components/ModelForm/components/UntranslatableFieldTooltip.vue'
import ModelFormFieldMixin from 'src/modules/admin/components/ModelForm/mixins/ModelFormFieldMixin'

export default {
  name: 'ModelFormToggle',
  components: {
    UntranslatableFieldTooltip
  },
  mixins: [ModelFormFieldMixin]
}
</script>
